import React from 'react';
import PropTypes from 'prop-types';
import TertiaryButton from './TertiaryButton';
import ButtonSizes from './ButtonSizes';

const AlternativeTertiaryButton = props => (
  <TertiaryButton variation="alternative" {...props} />
);

AlternativeTertiaryButton.defaultProps = {
  size: 'md',
};

// Also accepts all <button /> attributes
AlternativeTertiaryButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(ButtonSizes).isRequired,
};

export default AlternativeTertiaryButton;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Buttons/AlternativeTertiaryButton.jsx